import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand, randAlphaNumeric, randRecentDate } from '@ngneat/falso'

export type MicrochipCheckData = {
  microchip_id: string | null
  status: 'VALID' | 'NOT_MICROCHIPPED' | 'DUPLICATED' | 'INVALID'
  created: string
  modified: string
}

export const MicrochipCheckStatuses = [
  'VALID',
  'NOT_MICROCHIPPED',
  'DUPLICATED',
  'INVALID',
] as const

export const model = (Model as ModelDefinition<MicrochipCheckData>).extend({
  patient: belongsTo('patient', { inverse: 'microchipCheck' }),
  consultation: belongsTo('consultation', { inverse: null }),
})

export const factory = Factory.extend<MicrochipCheckData>({
  microchip_id() {
    return rand([randAlphaNumeric({ length: 15 }).join(''), null])
  },
  status() {
    return rand([...MicrochipCheckStatuses])
  },
  created: () => randRecentDate().toISOString(),
  modified: () => randRecentDate().toISOString(),
})
